import React from 'react'

const Box = ({ children, className, as: Elem = 'div', ...props }) => (
  <Elem className={`ui gp-box box-${props.group} ${className}`} {...props}>
    {children}
  </Elem>
)

Box.defaultProps = {
  className: '',
  style: {},
  group: ''
}

export default Box
